/* Scandi Collection package picker (replaces Kaching).
   Each package is its own variant ("1 stk", "2 stk", ...) with a fixed price
   per market, so the price shown here is exactly what checkout charges.
   Until the package variants exist, it falls back to plain quantity. */
(function () {
  var dataEl = document.getElementById('n-offer-data');
  var info = document.querySelector('.product__info-container');
  if (!dataEl || !info) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var form = info.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"][id^="product-form-"]');
  if (!form) return;

  var all = data.variants || [];
  var tierValues = data.tiers.map(function (t) { return t.value; });
  // Package mode: one option holds the package values.
  var pkgIndex = -1;
  if (all.length && all[0].options) {
    for (var oi = 0; oi < all[0].options.length; oi++) {
      if (all.some(function (v) { return tierValues.indexOf(v.options[oi]) > -1; })) { pkgIndex = oi; break; }
    }
  }
  var packageMode = pkgIndex > -1;
  // Other options (e.g. colour) are picked once for the whole package.
  var otherValues = [];
  if (all.length && all[0].options) {
    all[0].options.forEach(function (_, i) {
      if (i === pkgIndex) return;
      var vals = [];
      all.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      if (vals.length > 1) otherValues.push({ index: i, values: vals });
    });
  }

  var selected = data.tiers.findIndex(function (t) { return t.pre; });
  if (selected < 0) selected = 0;
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var root = document.createElement('div');
  root.className = 'n-offer';
  root.innerHTML =
    (data.heading ? '<p class="n-offer__heading"><span>' + esc(data.heading) + '</span></p>' : '') +
    '<div class="n-offer__list" role="radiogroup">' +
    data.tiers.map(function (t, i) {
      return '<label class="n-tier" data-i="' + i + '">' +
        '<input type="radio" name="n-tier" value="' + i + '">' +
        (t.badge ? '<span class="n-tier__badge">' + esc(t.badge) + '</span>' : '') +
        '<span class="n-tier__radio" aria-hidden="true"></span>' +
        '<span class="n-tier__main"><span class="n-tier__title">' + esc(t.title) +
          (t.label ? ' <span class="n-tier__label">' + esc(t.label) + '</span>' : '') + '</span>' +
          (t.sub ? '<span class="n-tier__sub">' + esc(t.sub) + '</span>' : '') + '</span>' +
        '<span class="n-tier__price"><strong>' + esc(t.price) + '</strong>' + (t.full > t.total ? '<s>' + esc(t.compare) + '</s>' : '') + '</span>' +
        '</label>';
    }).join('') + '</div>' +
    otherValues.map(function (o) {
      return '<div class="n-offer__opt"><select data-opt="' + o.index + '">' +
        o.values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('') +
        '</select></div>';
    }).join('');

  var buyBlock = form.closest('.product__info-container > *') || form;
  buyBlock.insertAdjacentElement('beforebegin', root);

  var qty = form.querySelector('input[name="quantity"]');
  if (!qty) { qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; form.appendChild(qty); }
  var idInput = form.querySelector('input[name="id"]');
  var atcPrice = info.querySelector('[id^="main-atc-price"]');

  function chosenVariant() {
    var t = data.tiers[selected];
    var picks = {};
    root.querySelectorAll('[data-opt]').forEach(function (s) { picks[s.getAttribute('data-opt')] = s.value; });
    return all.find(function (v) {
      if (packageMode && v.options[pkgIndex] !== t.value) return false;
      for (var k in picks) { if (v.options[+k] !== picks[k]) return false; }
      return true;
    }) || all[0];
  }

  function update() {
    var t = data.tiers[selected];
    root.querySelectorAll('.n-tier').forEach(function (el, i) {
      el.classList.toggle('is-selected', i === selected);
      el.querySelector('input').checked = i === selected;
    });
    var v = chosenVariant();
    if (idInput && v) {
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    qty.value = packageMode ? 1 : t.q;
    if (atcPrice) atcPrice.textContent = t.price;
  }
  root.addEventListener('change', function (e) {
    if (e.target.name === 'n-tier') selected = +e.target.value;
    update();
  });
  update();

  // The sticky bar scrolls to the packages instead of adding a single unit.
  document.querySelectorAll('sticky-atc button, .sticky-atc button[type="submit"]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  });
})();
